;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import type { Season } from "../season"
import { getCurrentSeason } from "../season"

/** Max published group listings per plan; Infinity means no numeric cap in product. */
export const GROUP_LISTING_LIMIT_BY_PLAN_KEY: Record<string, number> = {
  basic: 1,
  individual_pro: 3,
  individual_accelerate: 7,
  org_starter: 3,
  org_growth: 7,
  /** Enterprise / custom — treat as uncapped for gating. */
  org_enterprise: Number.POSITIVE_INFINITY,
}

export function getMaxGroupListingsForPlanKey(
  planKey: string | null | undefined,
): number {
  if (planKey == null || planKey === "") {
    return GROUP_LISTING_LIMIT_BY_PLAN_KEY.basic
  }
  return (
    GROUP_LISTING_LIMIT_BY_PLAN_KEY[planKey] ?? GROUP_LISTING_LIMIT_BY_PLAN_KEY.basic
  )
}

/** True when the org profile has been published (live). */
export function isOrganizationPublished(
  publishedAt: string | null | undefined,
): boolean {
  return publishedAt != null && String(publishedAt).trim() !== ""
}

/**
 * Cap used for create-group gating. Non-personal orgs that are not yet published
 * and have no active subscription may create up to 3 group listings while onboarding
 * (same allowance as org starter) without a paid plan.
 */
export function getEffectiveMaxGroupListingsForGate(params: {
  planKey: string | null | undefined
  isPersonal: boolean
  orgPublishedAt: string | null | undefined
  hasActiveSubscription: boolean
}): number {
  let max = getMaxGroupListingsForPlanKey(params.planKey)
  if (
    !params.isPersonal &&
    !isOrganizationPublished(params.orgPublishedAt) &&
    !params.hasActiveSubscription
  ) {
    max = Math.max(max, 3)
  }
  return max
}

export function isUnlimitedGroupListings(
  planKey: string | null | undefined,
): boolean {
  return !Number.isFinite(getMaxGroupListingsForPlanKey(planKey))
}

/** e.g. "List 1 group" vs "List up to 3 groups" */
export function formatGroupListingLimitLine(
  planKey: string | null | undefined,
): string {
  const max = getMaxGroupListingsForPlanKey(planKey)
  if (!Number.isFinite(max)) {
    return "Unlimited groups"
  }
  if (max === 1) {
    return "List 1 group"
  }
  return `List up to ${max} groups`
}

/** Short label for upgrade badges (modal, marketing). */
export function getSeasonDealBadgeLabel(season?: Season): string {
  const s = season ?? getCurrentSeason()
  return `${s} Deal`
}

export function buildSubscriptionCheckoutUrl(options: {
  planId: string
  orgType: "individual" | "organization"
  step?: number
}): string {
  const step = options.step ?? 1
  const q = new URLSearchParams({
    step: String(step),
    planId: options.planId,
    orgType: options.orgType,
  })
  return `/subscription?${q.toString()}`
}
